import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationFrench from "./translations/french.json";
const resources = {
  fr: { translation: translationFrench },
};

const initI18n=i18n
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    lng: "fr",
    fallbackLng: "fr",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    resources,

    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
      useSuspense: false,
    },
  }).then(() => {
    console.log("i18n initialized fleet-manager");
    return i18n;
  });

export default initI18n;
